import { createContext, useContext, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [isMobile, setIsMobile] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Визначаємо мобільний пристрій
  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  // Читання теми з cookie
  useEffect(() => {
    const match = document.cookie.match(/theme=(dark|light)/);
    const savedTheme = match ? match[1] : "light";
    setTheme(savedTheme);
    document.documentElement.classList.remove("dark");
    if (savedTheme === "dark") {
      document.documentElement.classList.add("dark");
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);

    // Вау-ефект тільки на мобільному
    if (isMobile) {
      setIsTransitioning(true);
      setTimeout(() => setIsTransitioning(false), 500);
    }

    document.documentElement.classList.remove("dark");
    if (newTheme === "dark") {
      document.documentElement.classList.add("dark");
    }

    document.cookie = `theme=${newTheme}; path=/; max-age=31536000`;
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {/* Вау-ефект затемнення тільки на мобільному */}
      <AnimatePresence>
        {isMobile && isTransitioning && (
          <motion.div
            key="theme-transition"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-[9999] bg-black pointer-events-none"
          />
        )}
      </AnimatePresence>

      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
